import Immutable from 'immutable';
import SimilarTitlesConstants from '../../constants/SimilarTitlesConstants';

const {
  REMOVE_SIMILAR_TITLES_REQUEST,
  REMOVE_SIMILAR_TITLES_SUCCESS,
  REMOVE_SIMILAR_TITLES_FAILURE
} = SimilarTitlesConstants;

const initialState = Immutable.Map();

export default function SimilarTitlesTransactionsReducer(state = initialState, action) {
  switch (action.type) {
    case REMOVE_SIMILAR_TITLES_REQUEST: {
      return state.mergeIn([action.metadataId, action.similarMetadataId], { isRemoving: true });
    }

    case REMOVE_SIMILAR_TITLES_SUCCESS:
    case REMOVE_SIMILAR_TITLES_FAILURE: {
      return state.delete(action.metadataId);
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/ugc/SimilarTitlesTransactionsReducer.js